import React from 'react';
import { func } from 'helpers';
import { Form, Input, Select } from 'antd';


const PayKYC = ({ form, kyc, step, submitting, isForeign }) => {

    const path = window.location.pathname.split('/')[1];

    React.useEffect(() => {
        if (process.env.space === 'local') {
            form.setFieldsValue({
                person: {
                    name: 'John Doe',
                    email: 'kode@mailinator.com',
                    phone: '0208125139',
                    city: 'City',
                    state: '',
                    address: 'Accra, Ghana',
                    zip: '00233',
                },
            });
        }
        if (step < 3) {
            form.setFieldsValue({
                code: '',
            });
        }
    }, [step]);

    return (
        <React.Fragment>
            {(!kyc.includes('code') && (kyc.includes('name') || path === 't')) && (
                <Form.Item
                    name={['person', 'name']} label={func.intl('Label.YourName', 'Your full name')}
                    rules={[{ required: step === 2, message: func.intl('Alert.Required', 'This field is required!'), },]}
                >
                    <Input type="text" size="large" autoComplete="off" placeholder="i.e: John Doe" disabled={submitting} />
                </Form.Item>
            )}
            {(!kyc.includes('code') && (kyc.includes('email') || path === 't')) && (
                <Form.Item
                    name={['person', 'email']} label={func.intl('Label.YourEmail', 'Your email adress')}
                    rules={[{ required: step === 2, message: func.intl('Alert.Required', 'This field is required!'), },]}
                    help={func.intl('Alert.ValidEmail', 'Please enter a valid email address')}
                >
                    <Input type="email" size="large" autoComplete="off" placeholder="i.e: johndoe@domain.com" disabled={submitting} />
                </Form.Item>
            )}
            {(!kyc.includes('code') && (kyc.includes('phone') || path === 't')) && (
                <Form.Item
                    name={['person', 'phone']} label={func.intl('Label.YourPhone', 'Your phone number')}
                    rules={[{ required: step === 2, message: func.intl('Alert.Required', 'This field is required!'), },]}
                >
                    <Input type="tel" size="large" autoComplete="off" addonBefore={`+${isForeign.myIP.phone}`} disabled={submitting} />
                </Form.Item>
            )}
            {kyc.includes('city') && (
                <Form.Item
                    name={['person', 'city']} label={func.intl('Label.YourCity', 'Your city')}
                    rules={[{ required: step === 2, message: func.intl('Alert.Required', 'This field is required!'), },]}
                >
                    <Input type="text" size="large" autoComplete="off" placeholder="" disabled={submitting} />
                </Form.Item>
            )}
            {kyc.includes('state') && (
                <Form.Item
                    name={['person', 'state']} label={func.intl('Label.YourState', 'Your state')}
                    rules={[{ required: step === 2, message: func.intl('Alert.Required', 'This field is required!'), },]}
                >
                    {
                        states[isForeign.country.toUpperCase()] ?
                            <Select size="large" autoComplete="off" showSearch optionFilterProp="children" placeholder="Choose an option" disabled={submitting}>
                                {states[isForeign.country.toUpperCase()].map(state => (
                                    <Select.Option key={state.value} value={state.value}>{state.label}</Select.Option>
                                ))}
                            </Select> :
                            <Input type="text" size="large" autoComplete="off" placeholder="" disabled={submitting} />
                    }

                </Form.Item>
            )}
            {kyc.includes('address') && (
                <Form.Item
                    name={['person', 'address']} label={func.intl('Label.YourAddress', 'Your address')}
                    rules={[{ required: step === 2, message: func.intl('Alert.Required', 'This field is required!'), },]}
                >
                    <Input type="text" size="large" autoComplete="off" placeholder="" disabled={submitting} />
                </Form.Item>
            )}
            {kyc.includes('zip') && (
                <Form.Item
                    name={['person', 'zip']} label={func.intl('Label.YourZip', 'Your zip code')}
                    rules={[{ required: step === 2, message: func.intl('Alert.Required', 'This field is required!'), },]}
                >
                    <Input type="tel" size="large" autoComplete="off" placeholder="" disabled={submitting} />
                </Form.Item>
            )}
            {(kyc.includes('code')) && (
                <div>
                    <div
                        className="alert alert-info p-2 small mb-4"
                        dangerouslySetInnerHTML={{
                            __html: func.intl(
                                'Alert.VerificationCodeSent',
                                'A verification code has been sent to <b>{email}</b>. Please check both your inbox and spam folder.',
                                { email: form.getFieldValue(['person', 'email']) },
                            )
                        }}
                    />
                    <Form.Item
                        name={['code']} label={func.intl('Label.VerificationCode', 'Verification code')}
                        rules={[{ required: step === 3, message: func.intl('Alert.Required', 'This field is required!'), },]}
                    >
                        <Input type="text" size="large" autoComplete="off" placeholder="1 2 3 4 5 6" disabled={submitting} />
                    </Form.Item>
                </div>
            )}
        </React.Fragment>
    );
}

export default PayKYC;